import React from 'react'
import {
  Accordion,
  AccordionItem,
  DescriptionList,
  type DescriptionListItem,
} from '@enamelai/design-system'
import './ReviewSections.css'

export type ReviewSection = {
  id: string
  title: string
  showInfo?: boolean
  fields?: DescriptionListItem[]
  content?: React.ReactNode
}

type ReviewSectionsProps = {
  sections: ReviewSection[]
}

const ReviewSections = ({
  sections,
}: ReviewSectionsProps): React.ReactElement => (
  <div className="scp-review-step">
    <Accordion
      allowMultiple
      className="scp-review"
      defaultOpenIds={sections.map((section) => section.id)}
    >
      {sections.map((section) => (
        <AccordionItem
          id={section.id}
          key={section.id}
          title={section.title}
          showInfo={section.showInfo}
        >
          {section.fields ? (
            <DescriptionList
              columns={1}
              variant="plain"
              items={section.fields}
            />
          ) : (
            section.content
          )}
        </AccordionItem>
      ))}
    </Accordion>
  </div>
)

export default ReviewSections
